<script>
import Password from '@wielink-application/shared/vue/components/form/horizontal/password.vue'

export default Password;
</script>